import styled from "@emotion/styled";

export const SearchNotFoundTextWrapper = styled.div(({theme}) => ({
  gridColumn: "1/-1",
  marginBottom: 40,
}));

export const ResultsAmountWrapper = styled.div(({theme}) => ({
  gridColumn: "1/-1",
  marginBottom: theme?.breakpoints?.isMobile ? 14 : 22,
}));

export const Wrapper = styled.div(({theme}) => ({
  marginTop: theme?.breakpoints?.isMobile ? 24 : 40,
  gridColumn: theme?.breakpoints?.isMobile
    ? "1/-1"
    : theme?.breakpoints?.md
      ? "2/15"
      : "4/14",
}));
